import React from 'react';
import Dthc from './Dthc';

export default class DthcContainer extends React.Component {
  render() {
    return (
      <Dthc {...this.props} outsideClickIgnoreClass='dthcIgnoreOnClickOutside' />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/Dthc/DthcContainer.js